// extracted by mini-css-extract-plugin
module.exports = {"socialsList":"styles_socialsList__bgeWi","socialsListItem":"styles_socialsListItem__lNyKD","credentials":"styles_credentials__6QgSU"};